import {css} from 'aphrodite';
import React from 'react';

import {getAccessibleOrInaccessibleId, isInaccessible} from 'graphql-client/InaccessibleInfo';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';
import {ChipSize} from 'ui-library/chips/Chip';
import WorksheetChip from 'ui-library/chips/WorksheetChip';

import AssigneeField from '../fields/AssigneeField';
import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {ScheduledOnField} from '../fields/ScheduledOnField';
import StatusField from '../fields/StatusField';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  PROCESS_TASK_DETAILS_LABELS,
  ProcessTaskGql,
} from '../ProcessTaskDetailsPageConstants';

export function getProceduresUnitOperationTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>,
  {
    experimentRunContent,
    procedureTemplateContent,
    conditionsContent,
    replicatesContent,
  }: {
    experimentRunContent: ProcessTaskDetailsRowContent;
    procedureTemplateContent: ProcessTaskDetailsRowContent;
    conditionsContent: ProcessTaskDetailsRowContent;
    replicatesContent: ProcessTaskDetailsRowContent;
  }
): Array<ProcessTaskDetailsRowContent> {
  const methodExecutionInstance = processTask.procedureMethodExecutionInstance;
  let worksheet = null;
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    worksheet = methodExecutionInstance.worksheet;
  }

  return [
    {
      label: PROCESS_TASK_DETAILS_LABELS.STATUS,
      component: <StatusField processTask={processTask} onUpdateTask={onUpdateTask} />,
    },
    {
      label: PROCESS_TASK_DETAILS_LABELS.ASSIGNEE,
      component: <AssigneeField processTask={processTask} onUpdateTask={onUpdateTask} />,
    },
    {
      label: PROCESS_TASK_DETAILS_LABELS.SCHEDULED_ON,
      component: <ScheduledOnField processTask={processTask} onUpdateTask={onUpdateTask} />,
    },
    {
      label: PROCESS_TASK_DETAILS_LABELS.EXECUTED_IN,
      component: worksheet ? (
        <WorksheetChip
          id={getAccessibleOrInaccessibleId(worksheet)}
          className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
          size={ChipSize.TABLE_CELL}
        />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
    experimentRunContent,
    procedureTemplateContent,
    conditionsContent,
    replicatesContent,
  ];
}
